import type { JSX } from 'react';
import Ticker from '@/sections/Ticker/Ticker';
import Hero from '@/sections/Hero/Hero';
import Markets from '@/sections/Markets/Markets';
import Why from '@/sections/Why/Why';
import How from '@/sections/How/How';
import Book from '@/sections/Book/Book';
import Stats from '@/sections/Stats/Stats';
import Waitlist from '@/sections/Waitlist/Waitlist';
import WaitlistStrip from '@/sections/Waitlist/WaitlistStrip';

export function Home(): JSX.Element {
  return (
    <>
      <Ticker />
      <Hero />
      <WaitlistStrip />
      <Markets />
      <Why />
      <How />
      <Book />
      <Stats />
      <Waitlist />
    </>
  );
}

export default Home;
